import { useState, useEffect, useContext  } from 'react';
import { useNavigate } from 'react-router-dom';

import {SettingsContext} from '../components/userSettingsContext';
import { DataGridPro, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';
import {TransformDataForGrid}  from "../components/helpers";
import { CcActionButton } from '../commonComponents/styledTexts';
import {jsonDateTimeToDateOnlyISO} from "../commonComponents/helperDateTime";
import { CcLoader } from '../commonComponents/generalComponents';

import axios from 'axios';
import { Icon as Iconify } from '@iconify/react';


const UserInfoPanel = (props) => {
    const [logins, setLogins] = useState([])
    const [updating, setUpdating] = useState(false)

    useEffect(() => {
        if (props.user) getLogins()
    }, [props.user])

    const getLogins = async () => {
        try {  
            setUpdating(true)
          const url = `${process.env.REACT_APP_LION_API_URL}/User/${props.user.uuId}/getLogins`;
          const response = await axios.get(url);
          const data = response.data;
            setLogins(data);
        } catch (error) {
          console.log(error);
        }
        finally {setUpdating(false)}
      }

    if (props.user === undefined) return <div>Select a user</div>

    return <div className='flex flex-col gap-y-2 font-poppins text-ccColorDarkTeal'>
        <div><span className='font-semibold'>User Id: </span>{props.user.uuId}</div>
        <div><span className='font-semibold'>Stripe Id: </span>{props.user.stripeCustomerId}</div>
        <div className='mt-2 text-lg font-semibold'>Logins</div>
        {updating && <div className='flex flex-row justify-center mt-4'>
               <CcLoader size={72} />
            </div>}
        {!updating && logins.map(l => <div className='border rounded border-gray-200 p-1'>
            <div className='flex flex-row items-center'>
                <div className='font-semibold'>{l.loginName}</div>
                <div className='grow'></div>
                <div className='bg-ccColorYellow font-semibold rounded text-sm p-1'>{l.loginType}</div>
            </div>
            
                <div className='text-sm w-28'>
                    <div className=''>{l.firstname}</div>
                    <div className=''>{l.surname}</div>
                </div>
                
                {l.emailValidated && <div className='flex flex-row gap-x-1 items-center text-green-500'>
                    <Iconify className='text-ccColorDarkTeal' icon="ic:outline-email" width={22} />
                    <div className='text-ccColorDarkTeal text-sm mr-2'>{l.email}</div>
                    <Iconify icon="mdi:tick-circle" width={22} />
                    <div>Validated</div>
                    </div>}
                {!l.emailValidated && <div className='flex flex-row gap-x-1 items-center text-red-500'>
                    <Iconify className='text-ccColorDarkTeal' icon="ic:outline-email" width={22} />
                    <div className='text-ccColorDarkTeal text-sm mr-2'>{l.email}</div>
                    <Iconify icon="streamline-ultimate:delete-2-bold" width={22} />
                    <div>Not Validated</div>
                    </div>}
                
            
        </div>)

        }
    </div>
}

export default function PageImpersonate() {
    /*
    props:

    NO props 
    */
    const {settings, setSettings} = useContext(SettingsContext);
    const apiRef = useGridApiRef();
    const [users, setUsers] = useState([]);
    const [topUsersToday, setTopUsersToday] = useState([]);
    const [topUsers7days, setTopUsers7days] = useState([]);
    const [impUUID, setImpUUID] = useState(null)
    const [selectedUserRow, setSelectedUserRow] = useState(undefined)

    const navigate = useNavigate();

  
    useEffect(() => {
        getUsers()
        getTopUsersToday()
        getTopUsers7Days()
        const info = localStorage.getItem('CCimpersonate');
        if (info !== null) setImpUUID(JSON.parse(info))
    }, [])

    const getUsers = async () => {
        try {  
          const url = `${process.env.REACT_APP_LION_API_URL}/User/getAll`;
          const response = await axios.get(url);
          const data = response.data;
        setUsers(TransformDataForGrid(data, 'userId'));

        } catch (error) {
          console.log(error);
        }
      }
    const getTopUsersToday = async () => {
    try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/User/getTop/today`;
        const response = await axios.get(url);
        const data = response.data;
        setTopUsersToday(TransformDataForGrid(data, 'uuId'));

    } catch (error) {
        console.log(error);
    }
    }
    const getTopUsers7Days = async () => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/User/getTop/7days`;
            const response = await axios.get(url);
            const data = response.data;
            setTopUsers7days(TransformDataForGrid(data, 'uuId'));
    
        } catch (error) {
            console.log(error);
        }
        }
    
    const handleImpersonate = (row) => {
        const impInfo = {uuId: row.uuId, userName: row.userName}
        localStorage.setItem("CCimpersonate", JSON.stringify(impInfo) );
        setImpUUID(impInfo)
        axios.defaults.headers.common['CCimpersonate'] = `${row.uuId}`;
        navigate("/")

    }
    const handleStopImpersonating = () => {
        localStorage.removeItem("CCimpersonate");
        delete axios.defaults.headers.common['CCimpersonate']
        setImpUUID(null)
        navigate("/")
    }

    const DatetimeStrToDateStr = (strDt) => {
        return jsonDateTimeToDateOnlyISO(strDt.value);
    }

    const columns = [
    //{ field: 'uuId', headerName: 'User Id', width: 300 },
    { field: 'userName', headerName: 'Business Name', width: 240 },
    { field: 'createdDate', headerName: 'Created', width: 130,
        valueGetter: DatetimeStrToDateStr,
     },
    { field: 'trialEndDate', headerName: 'Trial End', width: 130,
        valueGetter: DatetimeStrToDateStr,
        renderCell: (params) => {return params.value ? <div className='bg-ccColorYellow text-ccColorDarkTeal rounded p-2 font-semibold text-sm'>
            {params.value}
        </div>
        :<div></div>}
          ,
     },
    { field: 'email', headerName: 'Email', width: 240 },
    //{ field: 'stripeCustomerId', headerName: 'Stripe customerId', width: 180 },
    {
        field: 'actions',
        type: 'actions',
        width: 200,
        getActions: (params) => [
        <GridActionsCellItem icon={<CcActionButton ><div>Impersonate</div></CcActionButton>} onClick={() => { handleImpersonate(params.row);}} label="Impersonate" />,
        ]
    }
    
    ];
    const columnsTopUsers = [
        { field: 'id', headerName: 'User Id', width: 300 },
        { field: 'businessName', headerName: 'Business Name', width: 240 },
        { field: 'totalOpens', headerName: 'Total Opens', width: 240 },
        { field: 'totalClicks', headerName: 'Total Clicks', width: 240 },
        
        ];
          
    const getImpersonatingUsername = () => {
        //const impUUID = localStorage.getItem('CCimpersonate');
        if (impUUID === null) return undefined
        return impUUID.userName
        //const impUserInfo = users.find(u => u.uuId === impUUID);
        //if (impUserInfo) return impUserInfo.userName;
        //else return undefined
    }

    const handleUserRowClick = (params) => {
        //console.log(params.row)
        setSelectedUserRow(params.row)
    }
      
    return <div className='flex flex-col gap-2'>
                <div className='flex flex-row items-center gap-x-2 text-xl text-ccColorTeal'>
                    <div>Currently impersonating:</div>
                    <div className='font-bold'>{getImpersonatingUsername() ? getImpersonatingUsername() : "No one"}</div>
                    {getImpersonatingUsername() && <div>
                        <button type="button" className={`focus:outline-none text-white bg-ccColorSecondaryPink hover:bg-ccColorSecondaryPurple font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900`}
                            onClick={handleStopImpersonating}>
                            <div className='flex flex-row gap-2 items-center font-poppins'>
                                <div><Iconify icon="bi:sign-stop" width={22} /></div>
                                <div>Stop impersonating</div>
                            </div>
                        </button>                        
                        </div>}
                </div>
                <div className='flex flex-row gap-x-2'>
                    <div className='h-[560px]'>
                        <DataGridPro rows={users} columns={columns}
                                    apiRef={apiRef}
                                    hideFooter
                                    onRowClick={handleUserRowClick}
                        />
                    </div>
                    <div className='grow border rounded border-gray-200 p-2'>
                        <UserInfoPanel user={selectedUserRow} />
                    </div>
                </div>
                <div className='mt-2 text-lg font-semibold text-ccColorDarkTeal'>Top Users last 7 days</div>
                <div className='h-[400px]'>
                    <DataGridPro rows={topUsers7days} columns={columnsTopUsers}
                                apiRef={apiRef}
                                hideFooter
                    />
                </div>
                <div className='mt-2 text-lg font-semibold text-ccColorDarkTeal'>Top Users today</div>
                <div className='h-[400px]'>
                    <DataGridPro rows={topUsersToday} columns={columnsTopUsers}
                                apiRef={apiRef}
                                hideFooter
                    />
                </div>
</div>
}